import React, {useState} from 'react';
import './docsContent.scss'
import ArrowRightResponsive from '@images/icons/arrowGrayRight.svg'
import DocsHeroSection from "../docsHeroSection/docsHeroSection";
import DocsNavigation from "../docsNavigation/docsNavigation";
import {gql} from "@apollo/client";
import {client} from "../../../server-side/client";
import {Link} from "gatsby";
import CategoryTitleBox from "./_components/categoryTitleBox/categoryTitleBox";
import arrowBlue from '@images/docs/blue-arrow.svg'
import arrowGray from '@images/docs/gray-arrow.svg'
import arrowOrange from '@images/docs/orange-arrow.svg'
import arrowRed from '@images/docs/red-arrow.svg'
import doc from '@images/docs/doc.svg'

const DocsContent = ({sideContent, navigationContent, selectedTitle, selectedHeadline, faqContent, page}) => {
  const [activeHeadline, setActiveHeadline] = useState([selectedHeadline ? selectedHeadline : 'agency-white-label']);
  const [activeTitle, setActiveTitle] = useState(selectedTitle ? selectedTitle : '')
  const [isInputEmpty, setInputEmpty] = useState(true)
  const [articles, setArticles] = useState([])
  const [focused, setFocused] = React.useState(false)

  const onFocus = () => {
    setFocused(true)
  }

  const onBlur = () => setTimeout(() => {
    setFocused(false)
  }, 200);

  const handleLinkClicked = (event, title, parentSlug) => {
    event.target.parentElement.previousSibling.value = ''
    setFocused(false)
    setArticles([])
    setInputEmpty(true)
    setActiveTitle(title)
    setActiveHeadline(parentSlug)
  }

  const handleSearch = async (event) => {
    let param = event.target.value
    if (param === '') {
      setFocused(false)
      setArticles([])
      setInputEmpty(true)
    } else {
      setInputEmpty(false)
      setFocused(true)
      const data = await client.query({
        query: gql`
          query NewQuery {
            pages(where: {categoryName: "documentation", search: "${param}"}) {
              edges {
                node {
                  title
                  uri
                  content
                  parent {
                    node {
                      ... on Page {
                        slug
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      });
      setArticles(data.data.pages.edges)
    }
  };

  return (
    <>
      {activeTitle === 'Intro' &&
        <DocsHeroSection/>
      }
      <div className='documentation'>
        <div className='documentation__documentation-wrapper'>
          <div className='documentation__documentation-wrapper__side-navigation'>
            <input type="text" placeholder="Search" onKeyUp={event => handleSearch(event)} onFocus={onFocus} onBlur={onBlur}/>
            <div className='documentation__documentation-wrapper__side-navigation__search-result'>
              {
                focused ?
                  articles.length > 0 ?
                    articles.map((article) =>
                      <Link to={article.node.uri} key={article.node.title}
                            onClick={event => handleLinkClicked(event, article.node.title, article.node.parent.node.slug)}>
                        {article.node.title}
                      </Link>
                    )
                    :
                    !isInputEmpty ?
                      <p>No results found</p>
                      :
                      <></>
                  :
                  <></>
              }
            </div>
            <DocsNavigation
              navigationContent={navigationContent}
              activeHeadline={activeHeadline}
              activeTitle={activeTitle}
              setActiveHeadline={setActiveHeadline}
              setActiveTitle={setActiveTitle}
            />
          </div>
          <div className='documentation__documentation-wrapper__responsive-navigation'>
            {sideContent &&
              <div className='documentation__documentation-wrapper__responsive-navigation__location'>
                <div className='documentation__documentation-wrapper__responsive-navigation__location__text-arrow'>
                  <Link to='/docs'>
                    <p className='documentation__documentation-wrapper__responsive-navigation__location__text-arrow__headline'>
                      Documentation
                    </p>
                  </Link>
                  <img src={ArrowRightResponsive} alt='logo' loading="lazy"/>
                </div>
                <div className='documentation__documentation-wrapper__responsive-navigation__location__text-arrow'>
                  <p>
                    {sideContent[0].node.title === 'Intro' ?
                      sideContent[0].node.children.edges[0].node.title
                      :
                      sideContent[0].node.title
                    }
                  </p>
                  {activeTitle &&
                    <img src={ArrowRightResponsive} alt='logo' loading="lazy"/>
                  }
                </div>
                <p>{activeTitle}</p>
              </div>
            }
            <div className='documentation__documentation-wrapper__responsive-navigation__search'>
              <input type="text" placeholder="Search" onKeyUp={event => handleSearch(event)} onFocus={onFocus} onBlur={onBlur}/>
              <div className='documentation__documentation-wrapper__side-navigation__search-result'>
                {
                  focused ?
                    articles.length > 0 ?
                      articles.map((article) =>
                        <Link to={article.node.uri} key={article.node.title}
                              onClick={event => handleLinkClicked(event, article.node.title, article.node.parent.node.slug)}>
                          {article.node.title}
                        </Link>
                      )
                      :
                      !isInputEmpty ?
                        <p>No results found</p>
                        :
                        <></>
                    :
                    <></>
                }
              </div>
            </div>
          </div>
          {
            sideContent ?
              sideContent.map((item) => {
                return (
                  <div className='documentation__documentation-wrapper__docs-pages' key={item.node.title}>
                    <div dangerouslySetInnerHTML={{__html: `${item.node.children.edges[0].node.content}`}}/>
                  </div>
                )
              })
              :
              faqContent ?
                <div className='documentation__documentation-wrapper__docs-pages'>
                  <div dangerouslySetInnerHTML={{__html: `${faqContent.children.edges[0].node.content}`}}/>
                </div>
                :
              <div className='documentation__documentation-wrapper__content'>
                <div className='documentation__documentation-wrapper__content__text'>
                  <h1 className='documentation__documentation-wrapper__content__text__title'>Welcome to the Trafft
                    Documentation</h1>
                  <p className='documentation__documentation-wrapper__content__text__description'>Get started with the
                    most popular links below, or use search on the left hand side</p>
                </div>
                <div className='documentation__documentation-wrapper__content__blocks'>
                  <Link to='/docs/getting-started/quick-start-guide/' className='documentation__documentation-wrapper__content__blocks__single-block'>
                    <CategoryTitleBox
                      title='Quick Start Guide'
                      arrow={arrowBlue}
                    />
                  </Link>
                  <div className='documentation__documentation-wrapper__content__blocks__multi-blocks'>
                    <Link to='/docs/faq/' className='documentation__documentation-wrapper__content__blocks__multi-blocks__single-block
                                                documentation__documentation-wrapper__content__blocks__multi-blocks__single-block_orange'>
                      <CategoryTitleBox
                        title='FAQ'
                        arrow={arrowOrange}
                        theme='orange'
                      />
                    </Link>
                    <Link to='/docs/admin-views/dashboard/' className='documentation__documentation-wrapper__content__blocks__multi-blocks__single-block
                                                documentation__documentation-wrapper__content__blocks__multi-blocks__single-block_pink'>
                      <CategoryTitleBox
                        title='Dashboard View'
                        arrow={arrowRed}
                        theme='pink'
                      />
                    </Link>
                    <Link to='/docs/admin-views/calendar/' className='documentation__documentation-wrapper__content__blocks__multi-blocks__single-block
                                                documentation__documentation-wrapper__content__blocks__multi-blocks__single-block_gray'>
                      <CategoryTitleBox
                        title="Admin's Calendar"
                        arrow={arrowGray}
                        theme='gray'
                      />
                    </Link>
                  </div>
                </div>
                <div className='documentation__documentation-wrapper__content__featured-articles'>
                  <p>Featured articles</p>
                  <div className='documentation__documentation-wrapper__content__featured-articles__box'>
                    {navigationContent && navigationContent.map((parentArticle) =>
                      parentArticle.node.children.edges.map((article, index) =>
                        article.node.tags.nodes.map((articleTag) => articleTag.name === 'featured-article' ?
                          <div key={article.node.title}
                               className='documentation__documentation-wrapper__content__featured-articles__box__article'>
                            <img src={doc} alt="" loading="lazy" className='documentation__documentation-wrapper__content__featured-articles__box__article__img'/>
                            <Link to={article.node.uri}><p>{article.node.title}</p></Link>
                          </div>
                          :
                          <React.Fragment key={index}></React.Fragment>
                        )
                      ))}
                  </div>
                </div>
              </div>
          }
        </div>
      </div>
    </>
  )
}

export default DocsContent